export const LOADING_CRITICIDAD = "LOADING_CRITICIDAD";
export const SAVE_LOADING_CRITICIDAD = "SAVE_LOADING_CRITICIDAD";
export const GET_CRITICIDAD = "GET_CRITICIDAD";
export const FORM_FAIL = "FORM_FAIL";
export const CRITICIDAD_FAIL = "CRITICIDAD_FAIL";
